// path: dashboard/src/components/financeOfficer/FinanceCharts.jsx

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export default function FinanceCharts({ type, data }) {
  // 1. Payroll Trends (Line Chart) - Only show if type is payroll
  if (type === "payroll") {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
          <XAxis dataKey="period" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip 
            contentStyle={{ backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "4px" }}
            formatter={(value) => `$${value.toLocaleString()}`}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="netPay" 
            stroke="#f97316" 
            strokeWidth={3} 
            name="Net Pay" 
            dot={{ fill: "#f97316", r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="totalDeductions" 
            stroke="#ef4444" 
            strokeWidth={2} 
            name="Deductions" 
            strokeDasharray="5 5"
          />
        </LineChart>
      </ResponsiveContainer>
    );
  }

  // 2. Cash Flow (Bar Chart) - Aggregates whatever transactions are passed to it
  if (type === "cashflow") {
    const aggregateData = (transactions) => {
      const grouped = {};
      
      transactions.forEach(t => {
        if (!t.date) return;
        const date = new Date(t.date);
        // Use YYYY-MM as the key
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        
        if (!grouped[monthKey]) {
          grouped[monthKey] = { month: monthKey, Income: 0, Expense: 0 };
        }

        if (t.type === "INCOME") {
          grouped[monthKey].Income += t.amount;
        } else {
          grouped[monthKey].Expense += t.amount;
        }
      });

      return Object.values(grouped).sort((a, b) => a.month.localeCompare(b.month));
    };

    const chartData = aggregateData(data);

    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
          <XAxis dataKey="month" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip 
            cursor={{ fill: 'transparent' }}
            contentStyle={{ backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "4px" }}
            formatter={(value) => `$${value.toLocaleString()}`}
          />
          <Legend />
          <Bar dataKey="Income" fill="#10b981" radius={[4, 4, 0, 0]} name="Income" />
          <Bar dataKey="Expense" fill="#f97316" radius={[4, 4, 0, 0]} name="Expense" />
        </BarChart>
      </ResponsiveContainer>
    );
  }

  // Fallback for other types or no data
  return (
    <div className="h-[300px] flex items-center justify-center text-gray-400 bg-white rounded border border-dashed border-gray-200">
      <p>No chart data available for the selected view.</p>
    </div>
  );
}